export const getters = {
  itemsInCart: (state) => {
    return `${state.cart.reduce((total, item) => {
      return total + item.quantity;
    }, 0)}`;
  },
};
